import api, { unwrap } from './client';

export async function myReferrals() {
  return unwrap(await api.get('/referrals/me'));
}

export async function myWallet() {
  return unwrap(await api.get('/referrals/me/wallet'));
}

export async function trackReferralVisit(code) {
  return unwrap(await api.post('/referrals/track', { code }));
}

export async function adminListReferrals(params = {}) {
  return unwrap(await api.get('/admin/referrals', { params }));
}

export async function adminLeaderboard() {
  return unwrap(await api.get('/admin/referrals/leaderboard'));
}

export async function adminAnalytics() {
  return unwrap(await api.get('/admin/referrals/analytics'));
}

export async function adminInvalidate(id, reason) {
  return unwrap(await api.put(`/admin/referrals/${id}/invalidate`, { reason }));
}
